export const TRANSLATION_KEY = 'applications';

export const PATHS = {
  APPLICATIONS: '/application',
  APPLICATION_DETAILS: '/application/:appKey',
};

export const ApplicationEncryptionMethod = {
  AES_256_CBC: 'aes-256-cbc',
  AES_256_GCM: 'aes-256-gcm',
};
